export function normalizeVisitArrangementStatus(data = []) {
  if (!Array.isArray(data)) return data;

  return data.map(dashboardItem => ({
    ...dashboardItem,
    visitArrangementResponse: Array.isArray(dashboardItem.visitArrangementResponse)
      ? dashboardItem.visitArrangementResponse.map(visit => ({
          ...visit,
          statusType:
            visit.statusType === "Pending Visit Arrangement"
              ? "Visit Confirmed"
              : visit.statusType
        }))
      : dashboardItem.visitArrangementResponse
  }));
}